module.exports = __webpack_public_path__ + "assets/img/6.4e266d36.png";